export default "__VITE_ASSET__BzJcjYbv__"